<template>
    <div 
        v-scroll-to="{
            el: '#comments',
            offset: -30,
        }">
        <i class="fad fa-comment-dots contentAction articleActions__commentIcon"  style="--fa-primary-color: white;"></i>
        <slot v-bind:commentCount="commentCount"></slot>
    </div>
</template>
<script>
import EventBus from '../../EventBus';
export default {
    props: {
        initialCommentCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            commentCount: null
        }
    },
    mounted() {
        this.commentCount = this.initialCommentCount;

        EventBus.$on('update-comment-count', (count) => {
            this.commentCount = count;
        });
    },
    methods: {
        
    }
}
</script>